module.exports = __webpack_public_path__ + "img/current.0ac2a43a.png";